import * as React from 'react';
import { ArticleHeading2, ArticleParagraph1, UIText2 } from '@cian/ui-kit/typography';

import { SubmitButton } from '../SubmitButton';

import * as styles from './styles.css';

export interface IQuestionLayoutProps {
  title: string;
  description?: string | null;
  disableSubmit?: boolean;
  footer?: React.ReactElement;
  error?: string;
  buttonText?: string;
  showButtonPreloader?: boolean;
  buttonFullWidth?: boolean;

  onSubmit?(): void;
}

export const QuestionLayout: React.FC<React.PropsWithChildren<IQuestionLayoutProps>> = props => {
  const {
    description,
    children,
    title,
    onSubmit,
    disableSubmit,
    footer,
    buttonText,
    showButtonPreloader,
    error,
    buttonFullWidth,
  } = props;

  const handleSubmit = React.useCallback<React.FormEventHandler>(
    e => {
      e.preventDefault();
      /* istanbul ignore else */
      if (onSubmit) {
        onSubmit();
      }
    },
    [onSubmit],
  );

  return (
    <form onSubmit={handleSubmit} className={styles['container']}>
      <div>
        <ArticleHeading2>{title}</ArticleHeading2>
      </div>
      {description && (
        <div className={styles['description']}>
          <ArticleParagraph1 color="text-primary-default">{description}</ArticleParagraph1>
        </div>
      )}
      <div className={styles['answer']}>{children}</div>
      {onSubmit && (
        <SubmitButton disabled={disableSubmit} loading={showButtonPreloader} fullWidth={buttonFullWidth}>
          {buttonText || 'Далее'}
        </SubmitButton>
      )}
      {error && (
        <div className={styles['error']} data-testid="error">
          <UIText2 color="text-negative-default">{error}</UIText2>
        </div>
      )}
      {footer && (
        <div className={styles['footer']} data-testid="footer">
          {footer}
        </div>
      )}
    </form>
  );
};

QuestionLayout.displayName = 'QuestionLayout';
